import { Pane } from 'evergreen-ui';
import React from 'react';
import { ClientManagementLayout } from "../../layouts/ClientManagementLayout";
import { SubmittedRequestList } from "./SubmittedRequestList";
import { submittedRequestListReducer, initState } from "./submittedRequestListReducer";

export const SubmittedRequestListPage = () => {
    const [{
        pagination, 
        sortBy, 
        filter, 
        selected, 
        search, 
        pageSize 
    }, dispatch] = React.useReducer(submittedRequestListReducer, initState());

    return (
        <ClientManagementLayout customSelection={'Submitted Requests'}>
            <Pane minHeight="calc(100vh - 100px - 260px - 36px)" flexGrow={1}>
                <SubmittedRequestList 
                    dispatch={dispatch}
                    pagination={pagination}
                    filterValue={filter}
                    selectedRequest={selected}
                    searchText={search}
                    sortBy={sortBy}
                    pageSize={pageSize}
                />
            </Pane>
        </ClientManagementLayout>
    );
};
